import React from "react";

const AboutAreaSix = () => {
  return (
    <>
      {/* ================== AboutAreaSix start  ==================*/}
      <div className="about-area about-area-margin-bottom pd-top-120">
        <div className="container">
          <div className="box-shadow bg-white z-index-2 border-radius-5 p-xl-5 p-4">
            <div className="row">
              <div className="col-lg-6">
                <div
                  className="about-thumb-inner pe-xl-5 pb-5 me-xl-4"
                  data-aos="fade-right"
                  data-aos-delay="200"
                  data-aos-duration="1500"
                >
                  <img
                    className="main-img"
                    src="assets/img/about.webp"
                    alt="img"
                  />
                </div>
              </div>
              <div
                className="col-lg-6"
                data-aos="fade-left"
                data-aos-delay="200"
                data-aos-duration="1500"
              >
                <div className="section-title mt-5 mt-lg-0 mb-0">
                  <h6 className="sub-title-sky-blue">公司理念</h6>
                  <h2 className="title">智能创新驱动</h2>
                  <p className="content">
                    在不断演进的时代，智能技术正引领着创新的浪潮。我们相信，智能创新不仅是未来，也是现在。作为一家致力于引领智能革命的公司，我们将智能技术与创新精神相结合，为您提供前所未有的解决方案。
                  </p>
                  <p className="small-title">
                    我们的理念是：智能不仅仅是一种技术，更是一种力量，一种推动社会、企业和个人不断前进的力量。通过智能创新，我们能够重新定义业务模式，提高效率，增加竞争力，同时创造出更具可持续性的未来。
                  </p>
                  <div className="row mt-4">
                    <div className="col-md-4">
                      <div className="image-hover-rotate border-1 p-4 border-radius-5 text-center">
                        <div className="thumb mb-3">
                          <img
                            className="rotate-img"
                            src="assets/img/about/25.png"
                            alt="img"
                          />
                        </div>
                        <div className="details">
                          <h6 className="mb-0">深度学习</h6>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="image-hover-rotate border-1 p-4 border-radius-5 text-center">
                        <div className="thumb mb-3">
                          <img
                            className="rotate-img"
                            src="assets/img/about/26.png"
                            alt="img"
                          />
                        </div>
                        <div className="details">
                          <h6 className="mb-0">机器学习模型训练</h6>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="image-hover-rotate border-1 p-4 border-radius-5 text-center">
                        <div className="thumb mb-3">
                          <img
                            className="rotate-img"
                            src="assets/img/about/27.png"
                            alt="img"
                          />
                        </div>
                        <div className="details">
                          <h6 className="mb-0">客制自动化</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ================== AboutAreaSix End  ==================*/}
    </>
  );
};

export default AboutAreaSix;
